import { type Ref } from 'vue'
import { useConfirm, useNotification } from '@/shared/ui'
import { useTranslate, formatInventoryObjectNames } from '@/shared/lib'
import { type InventoryMapObjectData } from '@/widgets/InventoryMap'
import { useRemoveInventoryObject } from './api'
import { useRoute } from 'vue-router'

export const useRemoveInventObject = (
  objects?: Ref<InventoryMapObjectData[]>,
  selected?: Ref<number[]>,
) => {
  const { show } = useConfirm()
  const { trs } = useTranslate()
  const { addError } = useNotification()
  const route = useRoute()
  const { remove: objectsRemove } = useRemoveInventoryObject()

  const remove = (ids: number[]) => {
    const currentObjectId = Number(route.params.object_id)

    if (ids.includes(currentObjectId)) {
      addError(trs('validate.removed_root'))
      return
    }

    show({
      title: trs('itf.inventory_object_delete', {
        length: ids.length,
        names: formatInventoryObjectNames(
          ids.map((id) => ({ id, name: objects?.value.find((o) => o.id === id)?.name })),
        ),
      }),
      confirmFunc: () =>
        objectsRemove(ids).then(() => {
          if (!objects || !selected) return

          objects.value = objects.value.filter((item) => !ids.includes(item.id))
          selected.value = selected.value.filter((item) => !ids.includes(item))
        }),
    })
  }

  /**
   * Универсальная функция удаления объекта из любой точки приложения
   * @param id
   */
  const removeSimple = (id: number) => {
    return new Promise<void>((resolve, reject) => {
      show({
        title: trs('itf.inventory_object_simple_delete'),
        confirmFunc: () => objectsRemove([id]).then(resolve),
        cancelFunc: () => reject(new Error(trs('itf.cancelled'))),
      })
    })
  }

  return { remove, removeSimple }
}
